import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { seoForPath } from '../../features/public/seoConfig';

export function TermsPage() {
  return (
    <PublicContentPage seo={seoForPath('/terms')}>
      {publicPageHeading(
        'Terms of Use',
        'Terms governing use of the RideMaadi motorcycle riding and group ride application.',
      )}
      <div className="space-y-8 text-sm leading-relaxed text-muted sm:text-base">
        <section>
          <h2 className="text-base font-semibold text-content">Acceptance of terms</h2>
          <p className="mt-2">
            By accessing or using RideMaadi, you agree to these terms. If you do not agree, do not use
            the service.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Account and sign-in</h2>
          <p className="mt-2">
            You sign in using Google OAuth. You are responsible for activity under your account and for
            keeping your Google account secure.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Riding and safety</h2>
          <p className="mt-2">
            RideMaadi helps coordinate group rides but does not replace your judgment as a rider. Always
            obey traffic laws, ride within your limits, and prioritize safety. Captains and participants
            are responsible for their own conduct on the road.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Acceptable use</h2>
          <p className="mt-2">
            Do not misuse RideMaadi, attempt unauthorized access, scrape private data, or use the service
            in ways that harm other riders or the platform.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Service availability</h2>
          <p className="mt-2">
            RideMaadi is provided as-is. We may modify, suspend, or discontinue features with reasonable
            notice where possible.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Changes</h2>
          <p className="mt-2">
            We may update these terms from time to time. Continued use after changes constitutes acceptance
            of the updated terms.
          </p>
        </section>
        <p className="text-xs text-muted">Last updated: August 2026</p>
      </div>
    </PublicContentPage>
  );
}
